import React from 'react';
import { useParams } from 'react-router-dom';
import { default as FormsFactory } from '../../factory-components/forms/Forms';

const Forms = () => {
    const { formId } = useParams();

    return <FormsFactory formId={formId}/>;
};

export default Forms;
